import { IOmnniaSessionState } from "../types"
import { isObject } from "../utils/utils"

type Response = ng.IHttpResponse<any>

/**
 * This interceptor monitors 401 errors, and changes the session state to "unauthorized"
 * if a 401 error occurs
 */
/** @internal */
export class AuthInterceptor implements ng.IHttpInterceptor {

    static $inject = ["$q", "omniaSessionState"]

    constructor(private $q: ng.IQService, private readonly state: IOmnniaSessionState) {
    }

    responseError = (response: Response) => {

        if (this.state.handleUnauthorized && checkUnauthorized(response)) {
            this.state.unauthorized = true
        }

        return this.$q.reject(response)

    }
}

const urlExclusions = /(api\/service\/login)$/

/**
 * Checks that the response matches a 401 error returned by the API for "expected" reasons
 * (invalid token, session not found...)
 * @param response Response
 */
function checkUnauthorized(response: Response) {

    const { data, status, config } = response

    if (status != 401) return false

    if (urlExclusions.test(config.url)) {
        return false
    }

    if (isObject(data) && (data.OmniaAuthError)) {
        return true
    }

    return false

}
